import React from "react"

export default function Grid({ children, className }) {
  return (
    <div className={`${className ?? ""} gap-4 grid grid-cols-12 grid-flow-row`}>
      {children}
    </div>
  )
}
